import { AboutUI } from '../../modules';

const About = () => {
  return (
    <>
      <AboutUI />
    </>
  );
};

export { About };
